import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
   slideConfig = {
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: false
   };

  constructor() { }

  ngOnInit(): void {
     window.scrollTo(0, 0);
  }

}
